// extracted by mini-css-extract-plugin
export default {"readMore":"ReadMoreTag_readMore__BFQr+","notify":"ReadMoreTag_notify__knZ+M","shine":"ReadMoreTag_shine__beuLQ"};